import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["timeline", "statistics"];

  connect() {
    // Placeholder for future enhancements (charts, async fetch, etc.)
  }
}
